import { Alert, Autocomplete, FormControl, TextField } from '@mui/material';
import InputHeader from '../../../../components/InputHeader';
import { useLanguage } from '../../../../contexts/language';
import { SelectItem } from '../../../../types/core';
import { JourneyLogFormValues } from './types';
import { UseIotsAdminFormResult } from '../../../../hooks/useIotsAdminForm';

export interface VesselFormProps {
  vessels: SelectItem[];
  vesselsMap: Record<string, SelectItem>;
  isFetchingVessels: boolean;
  carriesCargo: boolean;
  carriesVehicles: boolean;
  validationMessages: string[];
  formManager: UseIotsAdminFormResult<JourneyLogFormValues>;
}

const VesselForm = ({
  vessels,
  vesselsMap,
  isFetchingVessels,
  carriesCargo,
  carriesVehicles,
  validationMessages,
  formManager,
}: VesselFormProps) => {
  const { t } = useLanguage();
  const {
    formState,
    materialInputHelpers: { getBaseProps, getTextFieldProps, renderError },
  } = formManager;

  return (
    <div>
      {validationMessages.map(message => (
        <Alert key={message} className="mb-2" color="warning">
          {message}
        </Alert>
      ))}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 auto-rows-auto">
        <label className="mb-4 col-span-full grid">
          <InputHeader required>{t('content.vessel')}</InputHeader>
          <FormControl error={getBaseProps('vesselId').error}>
            <Autocomplete<SelectItem>
              value={vesselsMap[formState.values.vesselId ?? ''] ?? null}
              onChange={(_event, selectedOption) => {
                const newVessel = selectedOption?.value ?? null;
                formState.updateValues({ vesselId: newVessel }, true);
              }}
              options={vessels}
              onBlur={getBaseProps('vesselId').onBlur}
              loading={isFetchingVessels}
              disabled={getBaseProps('vesselId').disabled || isFetchingVessels}
              renderInput={params => (
                <TextField
                  {...params}
                  error={getBaseProps('vesselId').error}
                  placeholder={t('content.select')}
                />
              )}
              getOptionLabel={option => option.label}
            />
            {renderError('vesselId')}
          </FormControl>
        </label>
        <label className="mb-4 col-span-full">
          <InputHeader required>{t('content.fuel-amount')}</InputHeader>
          <TextField {...getTextFieldProps('fuel')} />
        </label>
        {carriesCargo && (
          <label className="mb-4 col-span-full">
            <InputHeader required>{t('content.cargo-amount')}</InputHeader>
            <TextField {...getTextFieldProps('cargoAmount')} />
          </label>
        )}
        {carriesVehicles && (
          <label className="mb-4 col-span-full">
            <InputHeader required>{t('content.vehicles-amount')}</InputHeader>
            <TextField {...getTextFieldProps('numberOfVehicles')} />
          </label>
        )}
      </div>
    </div>
  );
};

export default VesselForm;
